// DepartmentDropdown.js

import React, { useEffect, useState } from "react";
import { Form, Select } from 'antd';
import {
    ReloadOutlined,
    SyncOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import AllergensApi from "../Apis/AllergensApi";

const AllergenModel = ({ }) => {

    const [Allergens, setAllergens] = useState([]);
    const [loading, setLoading] = useState(false);
    const [TotalPageNew, setTotalPageNew] = useState(null);
    const [page, setPage] = useState(0);

    const [IsReloadAllergensClicked, setIsReloadAllergensClicked] =
        useState(false);
    
        const handleReloadAllergensClick = async () => {
        setIsReloadAllergensClicked(true);

        try {
            setLoading(true);

            let currentPage = 0;
            let totalPages = 1;
            let allAllergens = [];

            do {
            const response = await AllergensApi.ListAllergensApi(currentPage, 10);
            totalPages = response?.totalPages || 0;
            allAllergens = [...allAllergens, ...(response?.payloadDto) || []];
            currentPage++;

            } while (currentPage < totalPages);

            setAllergens(allAllergens);
            setTotalPageNew(totalPages);
            setPage(currentPage);
        } catch (error) {
            console.error("Error fetching allergens:", error);
        } finally {
            setLoading(false);

        setTimeout(() => {
            setIsReloadAllergensClicked(false);
            }, 1000);
        }
    };

    const fetchAllergens = async () => {
        try {
            setLoading(true);

            let currentPage = 0;
            let totalPages = 1;
            let allAllergens = [];

            do {
                const response = await AllergensApi.ListAllergensApi(currentPage, 10);
                const allergens = response?.payloadDto || [];

                allAllergens = [...allAllergens, ...allergens];
                totalPages = response.totalPages || 0;
                currentPage++;
            }
            while (currentPage < totalPages);

            setAllergens(allAllergens);
            setTotalPageNew(totalPages);
            setPage(currentPage);

        } catch (error) {
            console.error('Error fetching allergens:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllergens();
    }, []);

    return (
        <><div className="row product-row d-flex ">
            <Form.Item
                name="Allergen"
                label="Allergen :"
                className="text-lable col-10"
                rules={[
                    {
                        required: true,
                        message: "Please Select Allergen.",
                    },
                ]}
            >
                <Select
                    mode="multiple"
                    className="control-Select mb-1"
                    placeholder="Select Allergen"
                >
                    {Allergens.map((option, index) => (
                        <Select.Option key={option.id} value={option.id}>
                            {option.allergensName}
                        </Select.Option>
                    ))}
                    {loading && (
                        <Select.Option disabled key="loading" value="loading">
                            Loading...
                        </Select.Option>
                    )}
                </Select>
            </Form.Item>
            <div className=" col-2">
                {IsReloadAllergensClicked ? (
                    <div className="refresh-btn">
                        <SyncOutlined spin className="px-2" />
                    </div>
                ) : (
                    <div
                        className="refresh-btn"
                        onClick={handleReloadAllergensClick}
                        style={{ cursor: "pointer" }}
                    >
                        <ReloadOutlined className="px-2" />
                    </div>
                )}
            </div>
        </div>
            <div className="row pb-2 ">
                <div className="col-4"></div>
                <div className="col-6">
                    <Link to={"/masters/allergens/add-allergens"} target="_blank">
                        <u>Create New Allergens</u>
                    </Link>
                </div>
            </div>
        </>

    );
};

export default AllergenModel;
